import React from 'react';
import { useLocation } from 'react-router-dom';
import { Button } from '@mantine/core';
import { TbCheck } from 'react-icons/tb';

import { isHandPlace, samePlace, stepLabels, STAGE_FOR_STEP } from './steps';
import { useWorkflowChrome } from '../WorkflowChromeContext';
import { usePeriodRun } from './PeriodRunContext';
import { Working } from './style';

/* What the run waits for a person to do — the button names the doing, not the going. */
const ASKS = {
  files: { what: 'This period needs its files', go: 'Add files' },
  mapping: { what: 'Nothing came across from the period before', go: 'Name the sheets' }
};

/* The one thing the run says on another page of its own project: it is your turn. */
const RunOverlay = () => {
  const location = useLocation();
  const chrome = useWorkflowChrome();
  const { run, state, narration, question, place, resumeFollowing } = usePeriodRun();

  /* A step that has just finished, said plainly, where the reader is looking. */
  const finished = state?.status === 'settled';
  const onFinishedStage = !!state?.step && chrome.activeStageKey === STAGE_FOR_STEP[state.step];

  if (run && finished && onFinishedStage && !question) {
    return (
      <Working>
        <div className="pill" data-done="true">
          <span className="tick" aria-hidden>
            <TbCheck size={13} />
          </span>
          <span className="what" role="status">
            {narration?.text || 'Finished'}
          </span>
          {narration?.detail && <span className="count">{narration.detail}</span>}
        </div>
      </Working>
    );
  }

  /* The one press in the middle of a run is NOT here. */

  const here = `${location.pathname}${location.search}`;
  /* Not while they are already standing at that door. */
  const away = place && !samePlace(here, place);

  const blocked = state?.status === 'blocked' ? ASKS[state.reason] : null;

  /* Done here, and the run is waiting on a page it will not take anybody off. */
  const onward =
    !blocked && away && isHandPlace(here) && state?.step
      ? {
          what: 'Ready when you are',
          go: `Open ${(stepLabels(run?.reportType)[state.step] || state.step).toLowerCase()}`
        }
      : null;

  const ask = blocked || onward;
  const inThisProject = !!run?.workflowId && location.pathname.includes(run.workflowId);
  /* The project's own page already lists the period and its Add Source File. */
  const onProjectPage =
    !!run?.workflowId &&
    location.pathname.replace(/\/+$/, '').endsWith(`/quaters/${run.workflowId}`);
  if (!run || !ask || !away || question || !inThisProject || onProjectPage) return null;

  /* Not a strip this time. */
  return (
    <Working>
      <div className="pill" data-cta="true">
        <span className="lines">
          <span className="what" role="status">
            {ask.what}
          </span>
          <em>and the rest of this period runs by itself</em>
        </span>
        <Button size="md" onClick={resumeFollowing}>
          {ask.go}
        </Button>
      </div>
    </Working>
  );
};

export default RunOverlay;
